import { render, staticRenderFns } from "./LogBarChart.vue?vue&type=template&id=110ad628"
import script from "./LogBarChart.vue?vue&type=script&lang=js"
export * from "./LogBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports